// extracted by mini-css-extract-plugin
export default {"containerFull":"Page_containerFull__TQ33s","container":"Page_container__BSaSs","header":"Page_header__GaeAT","footer":"Page_footer__+u1pU","headerSpace":"Page_headerSpace__CgF8g"};